import { renderLoginPage } from "../auth/login-page.js";
import { initTheme } from "./theme-init.js";

initTheme();

const container = document.getElementById("app");
if (container) {
  renderLoginPage(container);
}
